import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';
import { Playlist, PlaylistItem } from '../../models';
import { PlaylistService } from '../../services';
import * as common from '../../common';

@Component({
  selector: 'edit-playlist-dialog',
  templateUrl: './edit-playlist-dialog.html',
  styles: []
})
export class EditPlaylistDialogComponent implements OnInit {
  playlistName = '';
  playlistItems = [];

  constructor(
    public dialogRef: MatDialogRef<EditPlaylistDialogComponent>,
    public playlistService: PlaylistService,
    @Inject(MAT_DIALOG_DATA) public playlist: Playlist
  ) {

    this.playlistItems = this.playlist.items.sort((clipA: PlaylistItem, clipB: PlaylistItem) => clipA.seconds - clipB.seconds);
  }

  ngOnInit(): void {
    this.playlistName = this.playlist.name;
  }

  onDeleteItem(item: PlaylistItem) {
    const formattedTime = common.secondsToTime(item.seconds);
    const response = confirm(`Are you sure you want to delete ${item.name} at ${formattedTime} from the playlist?`);
    if (response) {
        const itemToDelete = this.playlist.items
            ? this.playlist.items.find(e => e.seconds === item.seconds)
            : undefined;

        if (itemToDelete) {
            console.info(`EditPlaylistDialog:DeleteItem - found item`);

            const newItems = this.playlist.items.filter(e => e.seconds !== item.seconds);
            if (newItems && newItems.length >= 0) {
                this.playlist.items = newItems;
                this.playlistItems = newItems;
                this.playlistService.update(this.playlist);
            }

        }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  formatTime(seconds: number) {
      return common.secondsToTime(seconds);
  }
}
